export const miniDrawerWidth = 70;
export const drawerWidth = 295;

export const miniDrawerWidthSeller = 70;
export const drawerWidthSeller = 266;

/**
 * Cek hak akses menu. aclCode boleh string (kode lama) atau array (EITHER:
 * kode baru ATAU kode lama) — transisi aman saat kode ACL baru di-rollout.
 */
export const isMenuAllowed = (aclDetail, aclCode) => {
    if (!aclDetail?.acl_code) return false;
    const codes = Array.isArray(aclCode) ? aclCode : [aclCode];
    return codes.some((code) => aclDetail.acl_code.includes(code));
};
